// src/firebase.js
import {initializeApp} from "firebase/app";
import {getAuth, signOut, updateProfile} from "firebase/auth";
import {getAnalytics} from "firebase/analytics";
import {getFunctions, httpsCallable} from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyA6HWW6TnOROwwbopHh0SL1_zpr24Pn5hQ",
    authDomain: "lifshitz-ai.firebaseapp.com",
    databaseURL: "https://lifshitz-ai-default-rtdb.firebaseio.com",
    projectId: "lifshitz-ai",
    storageBucket: "lifshitz-ai.appspot.com",
    messagingSenderId: "162199376481",
    appId: "1:162199376481:web:c16133439b1616ee909020",
    measurementId: "G-QSYEHZFT6Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const functions = getFunctions(app);

export {auth, signOut, updateProfile, analytics, functions, httpsCallable};
